module.exports = __webpack_public_path__ + "img/Anthony-Cornett.65740976.jpg";